var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPeople(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9999 5.96675C14.9499 5.95842 14.8916 5.95842 14.8416 5.96675C13.6916 5.92508 12.7749 4.98342 12.7749 3.81675C12.7749 2.62508 13.7332 1.66675 14.9249 1.66675C16.1166 1.66675 17.0749 2.63342 17.0749 3.81675C17.0666 4.98342 16.1499 5.92508 14.9999 5.96675Z",
    stroke: "currentColor",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1417 12.0333C15.2834 12.225 16.5417 12.025 17.425 11.4333C18.6 10.65 18.6 9.36664 17.425 8.58331C16.5334 7.99164 15.2584 7.79163 14.1167 7.99163",
    stroke: "currentColor",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.97539 5.96675C5.02539 5.95842 5.08372 5.95842 5.13372 5.96675C6.28372 5.92508 7.20039 4.98342 7.20039 3.81675C7.20039 2.62508 6.24206 1.66675 5.05039 1.66675C3.85873 1.66675 2.90039 2.63342 2.90039 3.81675C2.90872 4.98342 3.82539 5.92508 4.97539 5.96675Z",
    stroke: "currentColor",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.83353 12.0333C4.69186 12.225 3.43353 12.025 2.5502 11.4333C1.3752 10.65 1.3752 9.36664 2.5502 8.58331C3.44186 7.99164 4.71686 7.79163 5.85853 7.99163",
    stroke: "currentColor",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.9999 12.1916C9.9499 12.1833 9.89157 12.1833 9.84157 12.1916C8.69157 12.1499 7.7749 11.2083 7.7749 10.0416C7.7749 8.84994 8.73323 7.8916 9.9249 7.8916C11.1166 7.8916 12.0749 8.85827 12.0749 10.0416C12.0666 11.2083 11.1499 12.1583 9.9999 12.1916Z",
    stroke: "currentColor",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5751 14.8166C6.4001 15.5999 6.4001 16.8832 7.5751 17.6666C8.90843 18.5582 11.0918 18.5582 12.4251 17.6666C13.6001 16.8832 13.6001 15.5999 12.4251 14.8166C11.1001 13.9332 8.90843 13.9332 7.5751 14.8166Z",
    stroke: "currentColor",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeople);
export default __webpack_public_path__ + "static/media/people.daaea91cc2cc0283f19bb909eae03eee.svg";
export { ForwardRef as ReactComponent };